import {TradingAccountReportModel} from '@spa/api';

import {
    ReportTableActionsEnum,
    ReportTableButtonTypesEnum,
    ReportTableActionMenuTypesEnum,
    ReportTableConfigInterface,
    ReportTableData, ReportTableColumn
} from '../../../app/shared/components/report-table';

export const UserPortalIdSelector = 'userPortalIdSelector';
export const TradingPlatformIdSelector = 'tradingPlatformIdSelector';

export const TradingAccountsDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getAccountReferenceIdSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getAccountStatusNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getIsCashAccountSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getCurrencyCodeSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<number>({
            colId: TradingAccountReportModel.getBalanceSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: UserPortalIdSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingPlatformIdSelector,
            value: null,
            hidden: false
        })
    ];
};
export const TradingAccountPlansDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getAccountReferenceIdSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getAccountStatusNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getIsCashAccountSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getTradingPlanNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getTradingPlanTypeNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getTradingPlanPhaseSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingAccountReportModel.getAccountTradingPlanStatusNameSelector(),
            value: null,
            hidden: false
        })
    ];
};


export const TradingAccountsDataTableConfig = (showCheckboxActionMenu: boolean): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Account',
                selector: TradingAccountReportModel.getAccountReferenceIdSelector(),
            }),
            new ReportTableColumn({
                label: 'Status',
                selector: TradingAccountReportModel.getAccountStatusNameSelector(),
            }),
            new ReportTableColumn({
                label: 'Type',
                selector: TradingAccountReportModel.getIsCashAccountSelector(),
            }),
            new ReportTableColumn({
                label: 'Currency',
                selector: TradingAccountReportModel.getCurrencyCodeSelector(),
            }),
            new ReportTableColumn({
                label: 'Balance',
                selector: TradingAccountReportModel.getBalanceSelector(),
            }),
            new ReportTableColumn({
                label: 'Portal',
                selector: UserPortalIdSelector
            }),
            new ReportTableColumn({
                label: 'Platform',
                selector: TradingPlatformIdSelector
            })
        ],
        sortByRowIndex: true,
        hasToggleableOrCheckableRows: true,
        disableColumnsOptions: false,
        hiddenColumnIds: [],
        checkboxActionMenu: showCheckboxActionMenu,
        checkboxActionMenuTitle: 'Collect Rebates In',
        actionMenu: true,
        actionMenuType: ReportTableActionMenuTypesEnum.Buttons,
        actionMenuItems: [
            {
                buttonType: ReportTableButtonTypesEnum.Preview,
                action: ReportTableActionsEnum.Preview
            }
        ]
    };
};
export const TradingAccountsPlanDataTableConfig = (showCheckboxActionMenu: boolean): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Account',
                selector: TradingAccountReportModel.getAccountReferenceIdSelector(),
            }),
            new ReportTableColumn({
                label: 'Status',
                selector: TradingAccountReportModel.getAccountStatusNameSelector(),
            }),
            new ReportTableColumn({
                label: 'Type',
                selector: TradingAccountReportModel.getIsCashAccountSelector(),
            }),
            new ReportTableColumn({
                label: 'Plan',
                selector: TradingAccountReportModel.getTradingPlanNameSelector(),
            }),
            new ReportTableColumn({
                label: 'Plan Type',
                selector: TradingAccountReportModel.getTradingPlanTypeNameSelector(),
            }),
            new ReportTableColumn({
                label: 'Phase',
                selector: TradingAccountReportModel.getTradingPlanPhaseSelector(),
            }),
            new ReportTableColumn({
                label: 'Plan Status',
                selector: TradingAccountReportModel.getAccountTradingPlanStatusNameSelector(),
            })
        ],
        sortByRowIndex: true,
        hasToggleableOrCheckableRows: true,
        disableColumnsOptions: false,
        hiddenColumnIds: [],
        checkboxActionMenu: showCheckboxActionMenu,
        checkboxActionMenuTitle: 'Collect Rebates In',
        actionMenu: true,
        actionMenuType: ReportTableActionMenuTypesEnum.Buttons,
        actionMenuItems: [
            {
                buttonType: ReportTableButtonTypesEnum.Preview,
                action: ReportTableActionsEnum.Preview
            }
        ]
    };
};
